<template>
  <div
    v-if="min < max"
    class="filter-group"
  >
    <button
      class="filter-group__header"
      @click.prevent="visible = !visible"
    >
      <h3 class="filter-group__title">
        {{ $i18n.price }}
      </h3>
      <div class="filter-group__icon">
        <img
          src="/themes/base/app/img/icon-chevron-down.svg"
          alt="Chevron"
          :style="
            visible == true
              ? { transform: 'rotate(180deg)' }
              : { transform: 'rotate(0)' }
          "
        />
      </div>
    </button>
    <transition
      name="accordion"
      @before-enter="beforeEnter"
      @enter="enter"
      @before-leave="beforeLeave"
      @leave="leave"
    >
      <div
        v-show="visible"
        class="slider price-slider"
      >
        <div class="slider__header">
          <p class="slider__min">
            {{ sliderPrice.min }}
          </p>
          <p class="slider__max">
            {{ sliderPrice.max }}
          </p>
        </div>
        <div
          ref="slider"
          class="slider__slider price-slider__slider"
        ></div>
        <div class="slider__footer">
          <p>{{ $i18n.from }}</p>
          <p>{{ $i18n.to }}</p>
        </div>
        <div class="slider__inputs">
          <div class="slider__input">
            <input
              v-model="sliderPrice.min"
              type="number"
              name="from"
              step="0.01"
              :min="min"
              :max="max"
              @change="updateSlider"
            />
          </div>
          <div class="slider__input">
            <input
              v-model="sliderPrice.max"
              type="number"
              name="to"
              :step="step"
              :min="min"
              :max="max"
              @change="updateSlider"
            />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      step: 0.01,
      visible: true,
      filters: {
        price: {
          min: null,
          max: null
        }
      },
      sliderPrice: {
        min: null,
        max: null
      }
    };
  },
  computed: {
    products() {
      return this.$store.getters.products;
    },
    min() {
      let min = 9999999;
      this.products.forEach(product => {
        if (product.on_sale) {
          let sale_price = product.sale_price;
          sale_price =
            typeof sale_price == String
              ? sale_price.replace(",", "")
              : sale_price;
          min = parseFloat(sale_price) < min ? parseFloat(sale_price) : min;
        } else {
          let regular_price = product.regular_price;
          regular_price =
            typeof regular_price == String
              ? regular_price.replace(",", "")
              : regular_price;
          min =
            parseFloat(regular_price) < min ? parseFloat(regular_price) : min;
        }
      });
      return min;
    },
    max() {
      let max = 0;
      this.products.forEach(product => {
        if (product.on_sale) {
          let sale_price = product.sale_price_raw;

          max = parseFloat(sale_price) > max ? parseFloat(sale_price) : max;
        } else {
          let regular_price = product.regular_price_raw;

          max =
            parseFloat(regular_price) > max ? parseFloat(regular_price) : max;
        }
      });
      return max;
    }
  },
  watch: {
    filters: {
      deep: true,
      handler(filters) {
        if (this.min < this.max) {
          let prices = {};
          let query = Object.assign({}, this.$route.query);

          if (filters.price.min || filters.price.max) {
            query.page = 1;
            prices.min = filters.price.min ? filters.price.min : this.min;
            prices.max = filters.price.max ? filters.price.max : this.max;

            query.price = JSON.stringify(prices);

            this.$router
              .push({
                name: "Catalog",
                query
              })
              .catch(err => {});
          } else {
            delete query.price;

            this.$router
              .replace({
                name: "Catalog",
                query
              })
              .catch(err => {});
          }
        }
      }
    },
    sliderPrice: {
      deep: true,
      handler(sliderPrice) {
        if (this.min < sliderPrice.min || this.max > sliderPrice.max) {
          this.filters.price = sliderPrice;
        } else {
          this.filters.price = {
            min: null,
            max: null
          };
        }
      }
    },
    "$route.query": {
      deep: true,
      handler(query) {
        if (typeof query.price == "undefined" && this.min < this.max) {
          this.sliderPrice.min = this.min;
          this.sliderPrice.max = this.max;
          this.updateSlider();
        }
      }
    }
  },
  mounted() {
    const _self = this;

    if (this.min < this.max) {
      noUiSlider.create(_self.$refs.slider, {
        start: [_self.sliderPrice.min, _self.sliderPrice.max],
        connect: true,
        step: _self.step,
        range: {
          min: _self.min,
          max: _self.max
        }
      });

      this.$refs.slider.noUiSlider.on("update", (values, handle) => {
        _self.sliderPrice.min = parseFloat(values[0]);
        _self.sliderPrice.max = parseFloat(values[1]);
        this[handle ? "maxRange" : "minRange"] = parseInt(values[handle]);
      });
    }
  },
  created() {
    let query = this.$route.query;
    if (typeof query.price != "undefined") {
      this.filters.price = JSON.parse(query.price);
    }

    if (
      this.filters.price &&
      this.filters.price.min &&
      this.filters.price.max
    ) {
      this.sliderPrice.min = this.filters.price.min;
      this.sliderPrice.max = this.filters.price.max;
    } else {
      this.sliderPrice.min = this.min;
      this.sliderPrice.max = this.max;
    }
  },
  methods: {
    beforeEnter: function(el) {
      el.style.height = "0";
    },
    enter: function(el) {
      el.style.height = el.scrollHeight + "px";
    },
    beforeLeave: function(el) {
      el.style.height = el.scrollHeight + "px";
    },
    leave: function(el) {
      el.style.height = "0";
    },
    updateSlider() {
      this.$refs.slider.noUiSlider.set([
        this.sliderPrice.min,
        this.sliderPrice.max
      ]);
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/filter/Prices.vue